/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as CommiteeSlugRouteImport } from './routes/$commiteeSlug'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as CommiteeSlugIndexRouteImport } from './routes/$commiteeSlug/index'
import { Route as AccountBanqueRouteImport } from './routes/account/banque'
import { Route as AccountDetailsRouteImport } from './routes/account/details'
import { Route as AccountEntrepriseRouteImport } from './routes/account/entreprise'
import { Route as AccountLieuDeTravailRouteImport } from './routes/account/lieu-de-travail'
import { Route as AccountUsersRouteImport } from './routes/account/users'
import { Route as GestionCreateRouteImport } from './routes/gestion/create'
import { Route as GestionGeneralRouteImport } from './routes/gestion/general'
import { Route as CommiteeSlugAccountDetailsRouteImport } from './routes/$commiteeSlug/account/details'
import { Route as CommiteeSlugCreditNotesCreateRouteImport } from './routes/$commiteeSlug/credit-notes/create'
import { Route as CommiteeSlugImmobilisationsIndexRouteImport } from './routes/$commiteeSlug/immobilisations/index'
import { Route as CommiteeSlugImmobilisationsCreateRouteImport } from './routes/$commiteeSlug/immobilisations/create'
import { Route as CommiteeSlugImmobilisationsChar123IdChar125RouteImport } from './routes/$commiteeSlug/immobilisations/{-$id}'
import { Route as CommiteeSlugInventoryIndexRouteImport } from './routes/$commiteeSlug/inventory/index'
import { Route as CommiteeSlugInvoicesIndexRouteImport } from './routes/$commiteeSlug/invoices/index'
import { Route as CommiteeSlugInvoicesInvoiceIdRouteImport } from './routes/$commiteeSlug/invoices/$invoiceId'
import { Route as CommiteeSlugOrdersIndexRouteImport } from './routes/$commiteeSlug/orders/index'
import { Route as CommiteeSlugOrdersOrderIdRouteImport } from './routes/$commiteeSlug/orders/$orderId'
import { Route as CommiteeSlugOrdersCreateRouteImport } from './routes/$commiteeSlug/orders/create'
import { Route as CommiteeSlugPrestationParticipationsIndexRouteImport } from './routes/$commiteeSlug/prestation-participations/index'
import { Route as CommiteeSlugPrestationParticipationsCreateRouteImport } from './routes/$commiteeSlug/prestation-participations/create'
import { Route as CommiteeSlugPrestationParticipationsChar123IdChar125RouteImport } from './routes/$commiteeSlug/prestation-participations/{-$id}'
import { Route as CommiteeSlugPrestationRulesIndexRouteImport } from './routes/$commiteeSlug/prestation-rules/index'
import { Route as CommiteeSlugPrestationIndexRouteImport } from './routes/$commiteeSlug/prestation/index'
import { Route as CommiteeSlugPrestationCreateRouteImport } from './routes/$commiteeSlug/prestation/create'
import { Route as CommiteeSlugPrestationChar123IdChar125RouteImport } from './routes/$commiteeSlug/prestation/{-$id}'
import { Route as CommiteeSlugSuppliersIndexRouteImport } from './routes/$commiteeSlug/suppliers/index'
import { Route as CommiteeSlugSuppliersCreateRouteImport } from './routes/$commiteeSlug/suppliers/create'
import { Route as CommiteeSlugSuppliersChar123IdChar125RouteImport } from './routes/$commiteeSlug/suppliers/{-$id}'
import { Route as CommiteeSlugTreasuryCashRegisterRouteImport } from './routes/$commiteeSlug/treasury/cash-register'
import { Route as CommiteeSlugTreasuryPendingDisbursementsRouteImport } from './routes/$commiteeSlug/treasury/pending-disbursements'
import { Route as CommiteeSlugTreasuryPendingPaymentsRouteImport } from './routes/$commiteeSlug/treasury/pending-payments'
import { Route as AccountLieuDeTravailIndexRouteImport } from './routes/account/lieu-de-travail/index'
import { Route as AccountLieuDeTravailIdRouteImport } from './routes/account/lieu-de-travail/$id'
import { Route as GestionEntrepriseIdRouteImport } from './routes/gestion/entreprise/$id'
import { Route as CommiteeSlugAccountingBankReconciliationsCreationRouteImport } from './routes/$commiteeSlug/accounting/bank-reconciliations/creation'
import { Route as CommiteeSlugAccountingBankReconciliationsChar123IdChar125RouteImport } from './routes/$commiteeSlug/accounting/bank-reconciliations/{-$id}'
import { Route as CommiteeSlugAccountingClosingChar123IdChar125RouteImport } from './routes/$commiteeSlug/accounting/closing/{-$id}'
import { Route as CommiteeSlugAccountingFecIndexRouteImport } from './routes/$commiteeSlug/accounting/fec/index'
import { Route as CommiteeSlugAccountingParametersIndexRouteImport } from './routes/$commiteeSlug/accounting/parameters/index'
import { Route as CommiteeSlugAccountingParametersAccountPeriodsRouteImport } from './routes/$commiteeSlug/accounting/parameters/account-periods'
import { Route as CommiteeSlugAccountingParametersBanksRouteImport } from './routes/$commiteeSlug/accounting/parameters/banks'
import { Route as CommiteeSlugAccountingReportsIndexRouteImport } from './routes/$commiteeSlug/accounting/reports/index'
import { Route as CommiteeSlugAccountingTransactionsChar123IdChar125RouteImport } from './routes/$commiteeSlug/accounting/transactions/{-$id}'
import { Route as CommiteeSlugBeneficiariesBilletterieOrdersIndexRouteImport } from './routes/$commiteeSlug/beneficiaries/billetterie-orders/index'
import { Route as CommiteeSlugBeneficiariesDebtsIndexRouteImport } from './routes/$commiteeSlug/beneficiaries/debts/index'
import { Route as CommiteeSlugBeneficiariesEmployeesBeneficiariesChar123IdChar125RouteImport } from './routes/$commiteeSlug/beneficiaries/employees-beneficiaries/{-$id}'
import { Route as CommiteeSlugBeneficiariesEmployeesChar123IdChar125RouteImport } from './routes/$commiteeSlug/beneficiaries/employees/{-$id}'
import { Route as CommiteeSlugBeneficiariesTransactionsChar123IdChar125RouteImport } from './routes/$commiteeSlug/beneficiaries/transactions/{-$id}'
import { Route as CommiteeSlugTreasuryBankDepositsIndexRouteImport } from './routes/$commiteeSlug/treasury/bank-deposits/index'
import { Route as CommiteeSlugTreasuryBankDepositsDepositSlipNumberRouteImport } from './routes/$commiteeSlug/treasury/bank-deposits/$depositSlipNumber'
import { Route as GestionEntrepriseIdIndexRouteImport } from './routes/gestion/entreprise/$id/index'
import { Route as GestionEntrepriseIdBanqueRouteImport } from './routes/gestion/entreprise/$id/banque'
import { Route as GestionEntrepriseIdLieuDeTravailRouteImport } from './routes/gestion/entreprise/$id/lieu-de-travail'
import { Route as GestionEntrepriseIdUsersRouteImport } from './routes/gestion/entreprise/$id/users'
import { Route as CommiteeSlugAccountingParametersFinancialAccountsChar123IdChar125RouteImport } from './routes/$commiteeSlug/accounting/parameters/financial-accounts/{-$id}'
import { Route as CommiteeSlugAccountingParametersJournalsChar123IdChar125RouteImport } from './routes/$commiteeSlug/accounting/parameters/journals/{-$id}'
import { Route as CommiteeSlugAccountingParametersTransactionCategoriesChar123IdChar125RouteImport } from './routes/$commiteeSlug/accounting/parameters/transaction-categories/{-$id}'
import { Route as CommiteeSlugAccountingParametersTransactionModelsIndexRouteImport } from './routes/$commiteeSlug/accounting/parameters/transaction-models/index'
import { Route as CommiteeSlugBeneficiariesTransactionsCreateIndexRouteImport } from './routes/$commiteeSlug/beneficiaries/transactions/create/index'
import { Route as CommiteeSlugSuppliersSupplierIdOrdersCreateRouteImport } from './routes/$commiteeSlug/suppliers/$supplierId/orders/create'
import { Route as CommiteeSlugSuppliersSupplierIdPaymentsCreateRouteImport } from './routes/$commiteeSlug/suppliers/$supplierId/payments/create'

const CommiteeSlugRoute = CommiteeSlugRouteImport.update({
  id: '/$commiteeSlug',
  path: '/$commiteeSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const CommiteeSlugIndexRoute = CommiteeSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CommiteeSlugRoute,
} as any)
const AccountBanqueRoute = AccountBanqueRouteImport.update({
  id: '/account/banque',
  path: '/account/banque',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountDetailsRoute = AccountDetailsRouteImport.update({
  id: '/account/details',
  path: '/account/details',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountEntrepriseRoute = AccountEntrepriseRouteImport.update({
  id: '/account/entreprise',
  path: '/account/entreprise',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountLieuDeTravailRoute = AccountLieuDeTravailRouteImport.update({
  id: '/account/lieu-de-travail',
  path: '/account/lieu-de-travail',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountUsersRoute = AccountUsersRouteImport.update({
  id: '/account/users',
  path: '/account/users',
  getParentRoute: () => rootRouteImport,
} as any)
const GestionCreateRoute = GestionCreateRouteImport.update({
  id: '/gestion/create',
  path: '/gestion/create',
  getParentRoute: () => rootRouteImport,
} as any)
const GestionGeneralRoute = GestionGeneralRouteImport.update({
  id: '/gestion/general',
  path: '/gestion/general',
  getParentRoute: () => rootRouteImport,
} as any)
const CommiteeSlugAccountDetailsRoute =
  CommiteeSlugAccountDetailsRouteImport.update({
    id: '/account/details',
    path: '/account/details',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugCreditNotesCreateRoute =
  CommiteeSlugCreditNotesCreateRouteImport.update({
    id: '/credit-notes/create',
    path: '/credit-notes/create',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugImmobilisationsIndexRoute =
  CommiteeSlugImmobilisationsIndexRouteImport.update({
    id: '/immobilisations/',
    path: '/immobilisations/',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugImmobilisationsCreateRoute =
  CommiteeSlugImmobilisationsCreateRouteImport.update({
    id: '/immobilisations/create',
    path: '/immobilisations/create',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugImmobilisationsChar123IdChar125Route =
  CommiteeSlugImmobilisationsChar123IdChar125RouteImport.update({
    id: '/immobilisations/{-$id}',
    path: '/immobilisations/{-$id}',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugInventoryIndexRoute =
  CommiteeSlugInventoryIndexRouteImport.update({
    id: '/inventory/',
    path: '/inventory/',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugInvoicesIndexRoute =
  CommiteeSlugInvoicesIndexRouteImport.update({
    id: '/invoices/',
    path: '/invoices/',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugInvoicesInvoiceIdRoute =
  CommiteeSlugInvoicesInvoiceIdRouteImport.update({
    id: '/invoices/$invoiceId',
    path: '/invoices/$invoiceId',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugOrdersIndexRoute = CommiteeSlugOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => CommiteeSlugRoute,
} as any)
const CommiteeSlugOrdersOrderIdRoute =
  CommiteeSlugOrdersOrderIdRouteImport.update({
    id: '/orders/$orderId',
    path: '/orders/$orderId',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugOrdersCreateRoute =
  CommiteeSlugOrdersCreateRouteImport.update({
    id: '/orders/create',
    path: '/orders/create',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugPrestationParticipationsIndexRoute =
  CommiteeSlugPrestationParticipationsIndexRouteImport.update({
    id: '/prestation-participations/',
    path: '/prestation-participations/',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugPrestationParticipationsCreateRoute =
  CommiteeSlugPrestationParticipationsCreateRouteImport.update({
    id: '/prestation-participations/create',
    path: '/prestation-participations/create',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugPrestationParticipationsChar123IdChar125Route =
  CommiteeSlugPrestationParticipationsChar123IdChar125RouteImport.update({
    id: '/prestation-participations/{-$id}',
    path: '/prestation-participations/{-$id}',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugPrestationRulesIndexRoute =
  CommiteeSlugPrestationRulesIndexRouteImport.update({
    id: '/prestation-rules/',
    path: '/prestation-rules/',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugPrestationIndexRoute =
  CommiteeSlugPrestationIndexRouteImport.update({
    id: '/prestation/',
    path: '/prestation/',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugPrestationCreateRoute =
  CommiteeSlugPrestationCreateRouteImport.update({
    id: '/prestation/create',
    path: '/prestation/create',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugPrestationChar123IdChar125Route =
  CommiteeSlugPrestationChar123IdChar125RouteImport.update({
    id: '/prestation/{-$id}',
    path: '/prestation/{-$id}',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugSuppliersIndexRoute =
  CommiteeSlugSuppliersIndexRouteImport.update({
    id: '/suppliers/',
    path: '/suppliers/',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugSuppliersCreateRoute =
  CommiteeSlugSuppliersCreateRouteImport.update({
    id: '/suppliers/create',
    path: '/suppliers/create',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugSuppliersChar123IdChar125Route =
  CommiteeSlugSuppliersChar123IdChar125RouteImport.update({
    id: '/suppliers/{-$id}',
    path: '/suppliers/{-$id}',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugTreasuryCashRegisterRoute =
  CommiteeSlugTreasuryCashRegisterRouteImport.update({
    id: '/treasury/cash-register',
    path: '/treasury/cash-register',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugTreasuryPendingDisbursementsRoute =
  CommiteeSlugTreasuryPendingDisbursementsRouteImport.update({
    id: '/treasury/pending-disbursements',
    path: '/treasury/pending-disbursements',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugTreasuryPendingPaymentsRoute =
  CommiteeSlugTreasuryPendingPaymentsRouteImport.update({
    id: '/treasury/pending-payments',
    path: '/treasury/pending-payments',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const AccountLieuDeTravailIndexRoute =
  AccountLieuDeTravailIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AccountLieuDeTravailRoute,
  } as any)
const AccountLieuDeTravailIdRoute = AccountLieuDeTravailIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AccountLieuDeTravailRoute,
} as any)
const GestionEntrepriseIdRoute = GestionEntrepriseIdRouteImport.update({
  id: '/gestion/entreprise/$id',
  path: '/gestion/entreprise/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CommiteeSlugAccountingBankReconciliationsCreationRoute =
  CommiteeSlugAccountingBankReconciliationsCreationRouteImport.update({
    id: '/accounting/bank-reconciliations/creation',
    path: '/accounting/bank-reconciliations/creation',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugAccountingBankReconciliationsChar123IdChar125Route =
  CommiteeSlugAccountingBankReconciliationsChar123IdChar125RouteImport.update({
    id: '/accounting/bank-reconciliations/{-$id}',
    path: '/accounting/bank-reconciliations/{-$id}',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugAccountingClosingChar123IdChar125Route =
  CommiteeSlugAccountingClosingChar123IdChar125RouteImport.update({
    id: '/accounting/closing/{-$id}',
    path: '/accounting/closing/{-$id}',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugAccountingFecIndexRoute =
  CommiteeSlugAccountingFecIndexRouteImport.update({
    id: '/accounting/fec/',
    path: '/accounting/fec/',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugAccountingParametersIndexRoute =
  CommiteeSlugAccountingParametersIndexRouteImport.update({
    id: '/accounting/parameters/',
    path: '/accounting/parameters/',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugAccountingParametersAccountPeriodsRoute =
  CommiteeSlugAccountingParametersAccountPeriodsRouteImport.update({
    id: '/accounting/parameters/account-periods',
    path: '/accounting/parameters/account-periods',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugAccountingParametersBanksRoute =
  CommiteeSlugAccountingParametersBanksRouteImport.update({
    id: '/accounting/parameters/banks',
    path: '/accounting/parameters/banks',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugAccountingReportsIndexRoute =
  CommiteeSlugAccountingReportsIndexRouteImport.update({
    id: '/accounting/reports/',
    path: '/accounting/reports/',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugAccountingTransactionsChar123IdChar125Route =
  CommiteeSlugAccountingTransactionsChar123IdChar125RouteImport.update({
    id: '/accounting/transactions/{-$id}',
    path: '/accounting/transactions/{-$id}',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugBeneficiariesBilletterieOrdersIndexRoute =
  CommiteeSlugBeneficiariesBilletterieOrdersIndexRouteImport.update({
    id: '/beneficiaries/billetterie-orders/',
    path: '/beneficiaries/billetterie-orders/',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugBeneficiariesDebtsIndexRoute =
  CommiteeSlugBeneficiariesDebtsIndexRouteImport.update({
    id: '/beneficiaries/debts/',
    path: '/beneficiaries/debts/',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugBeneficiariesEmployeesBeneficiariesChar123IdChar125Route =
  CommiteeSlugBeneficiariesEmployeesBeneficiariesChar123IdChar125RouteImport.update(
    {
      id: '/beneficiaries/employees-beneficiaries/{-$id}',
      path: '/beneficiaries/employees-beneficiaries/{-$id}',
      getParentRoute: () => CommiteeSlugRoute,
    } as any,
  )
const CommiteeSlugBeneficiariesEmployeesChar123IdChar125Route =
  CommiteeSlugBeneficiariesEmployeesChar123IdChar125RouteImport.update({
    id: '/beneficiaries/employees/{-$id}',
    path: '/beneficiaries/employees/{-$id}',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugBeneficiariesTransactionsChar123IdChar125Route =
  CommiteeSlugBeneficiariesTransactionsChar123IdChar125RouteImport.update({
    id: '/beneficiaries/transactions/{-$id}',
    path: '/beneficiaries/transactions/{-$id}',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugTreasuryBankDepositsIndexRoute =
  CommiteeSlugTreasuryBankDepositsIndexRouteImport.update({
    id: '/treasury/bank-deposits/',
    path: '/treasury/bank-deposits/',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugTreasuryBankDepositsDepositSlipNumberRoute =
  CommiteeSlugTreasuryBankDepositsDepositSlipNumberRouteImport.update({
    id: '/treasury/bank-deposits/$depositSlipNumber',
    path: '/treasury/bank-deposits/$depositSlipNumber',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const GestionEntrepriseIdIndexRoute =
  GestionEntrepriseIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => GestionEntrepriseIdRoute,
  } as any)
const GestionEntrepriseIdBanqueRoute =
  GestionEntrepriseIdBanqueRouteImport.update({
    id: '/banque',
    path: '/banque',
    getParentRoute: () => GestionEntrepriseIdRoute,
  } as any)
const GestionEntrepriseIdLieuDeTravailRoute =
  GestionEntrepriseIdLieuDeTravailRouteImport.update({
    id: '/lieu-de-travail',
    path: '/lieu-de-travail',
    getParentRoute: () => GestionEntrepriseIdRoute,
  } as any)
const GestionEntrepriseIdUsersRoute =
  GestionEntrepriseIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => GestionEntrepriseIdRoute,
  } as any)
const CommiteeSlugAccountingParametersFinancialAccountsChar123IdChar125Route =
  CommiteeSlugAccountingParametersFinancialAccountsChar123IdChar125RouteImport.update(
    {
      id: '/accounting/parameters/financial-accounts/{-$id}',
      path: '/accounting/parameters/financial-accounts/{-$id}',
      getParentRoute: () => CommiteeSlugRoute,
    } as any,
  )
const CommiteeSlugAccountingParametersJournalsChar123IdChar125Route =
  CommiteeSlugAccountingParametersJournalsChar123IdChar125RouteImport.update({
    id: '/accounting/parameters/journals/{-$id}',
    path: '/accounting/parameters/journals/{-$id}',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugAccountingParametersTransactionCategoriesChar123IdChar125Route =
  CommiteeSlugAccountingParametersTransactionCategoriesChar123IdChar125RouteImport.update(
    {
      id: '/accounting/parameters/transaction-categories/{-$id}',
      path: '/accounting/parameters/transaction-categories/{-$id}',
      getParentRoute: () => CommiteeSlugRoute,
    } as any,
  )
const CommiteeSlugAccountingParametersTransactionModelsIndexRoute =
  CommiteeSlugAccountingParametersTransactionModelsIndexRouteImport.update({
    id: '/accounting/parameters/transaction-models/',
    path: '/accounting/parameters/transaction-models/',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugBeneficiariesTransactionsCreateIndexRoute =
  CommiteeSlugBeneficiariesTransactionsCreateIndexRouteImport.update({
    id: '/beneficiaries/transactions/create/',
    path: '/beneficiaries/transactions/create/',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugSuppliersSupplierIdOrdersCreateRoute =
  CommiteeSlugSuppliersSupplierIdOrdersCreateRouteImport.update({
    id: '/suppliers/$supplierId/orders/create',
    path: '/suppliers/$supplierId/orders/create',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)
const CommiteeSlugSuppliersSupplierIdPaymentsCreateRoute =
  CommiteeSlugSuppliersSupplierIdPaymentsCreateRouteImport.update({
    id: '/suppliers/$supplierId/payments/create',
    path: '/suppliers/$supplierId/payments/create',
    getParentRoute: () => CommiteeSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/$commiteeSlug': typeof CommiteeSlugRouteWithChildren
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/account/banque': typeof AccountBanqueRoute
  '/account/details': typeof AccountDetailsRoute
  '/account/entreprise': typeof AccountEntrepriseRoute
  '/account/lieu-de-travail': typeof AccountLieuDeTravailRouteWithChildren
  '/account/users': typeof AccountUsersRoute
  '/gestion/create': typeof GestionCreateRoute
  '/gestion/general': typeof GestionGeneralRoute
  '/$commiteeSlug/': typeof CommiteeSlugIndexRoute
  '/$commiteeSlug/account/details': typeof CommiteeSlugAccountDetailsRoute
  '/$commiteeSlug/credit-notes/create': typeof CommiteeSlugCreditNotesCreateRoute
  '/$commiteeSlug/immobilisations/create': typeof CommiteeSlugImmobilisationsCreateRoute
  '/$commiteeSlug/immobilisations/{-$id}': typeof CommiteeSlugImmobilisationsChar123IdChar125Route
  '/$commiteeSlug/invoices/$invoiceId': typeof CommiteeSlugInvoicesInvoiceIdRoute
  '/$commiteeSlug/orders/$orderId': typeof CommiteeSlugOrdersOrderIdRoute
  '/$commiteeSlug/orders/create': typeof CommiteeSlugOrdersCreateRoute
  '/$commiteeSlug/prestation-participations/create': typeof CommiteeSlugPrestationParticipationsCreateRoute
  '/$commiteeSlug/prestation-participations/{-$id}': typeof CommiteeSlugPrestationParticipationsChar123IdChar125Route
  '/$commiteeSlug/prestation/create': typeof CommiteeSlugPrestationCreateRoute
  '/$commiteeSlug/prestation/{-$id}': typeof CommiteeSlugPrestationChar123IdChar125Route
  '/$commiteeSlug/suppliers/create': typeof CommiteeSlugSuppliersCreateRoute
  '/$commiteeSlug/suppliers/{-$id}': typeof CommiteeSlugSuppliersChar123IdChar125Route
  '/$commiteeSlug/treasury/cash-register': typeof CommiteeSlugTreasuryCashRegisterRoute
  '/$commiteeSlug/treasury/pending-disbursements': typeof CommiteeSlugTreasuryPendingDisbursementsRoute
  '/$commiteeSlug/treasury/pending-payments': typeof CommiteeSlugTreasuryPendingPaymentsRoute
  '/account/lieu-de-travail/$id': typeof AccountLieuDeTravailIdRoute
  '/gestion/entreprise/$id': typeof GestionEntrepriseIdRouteWithChildren
  '/$commiteeSlug/immobilisations/': typeof CommiteeSlugImmobilisationsIndexRoute
  '/$commiteeSlug/inventory/': typeof CommiteeSlugInventoryIndexRoute
  '/$commiteeSlug/invoices/': typeof CommiteeSlugInvoicesIndexRoute
  '/$commiteeSlug/orders/': typeof CommiteeSlugOrdersIndexRoute
  '/$commiteeSlug/prestation-participations/': typeof CommiteeSlugPrestationParticipationsIndexRoute
  '/$commiteeSlug/prestation-rules/': typeof CommiteeSlugPrestationRulesIndexRoute
  '/$commiteeSlug/prestation/': typeof CommiteeSlugPrestationIndexRoute
  '/$commiteeSlug/suppliers/': typeof CommiteeSlugSuppliersIndexRoute
  '/account/lieu-de-travail/': typeof AccountLieuDeTravailIndexRoute
  '/$commiteeSlug/accounting/bank-reconciliations/creation': typeof CommiteeSlugAccountingBankReconciliationsCreationRoute
  '/$commiteeSlug/accounting/bank-reconciliations/{-$id}': typeof CommiteeSlugAccountingBankReconciliationsChar123IdChar125Route
  '/$commiteeSlug/accounting/closing/{-$id}': typeof CommiteeSlugAccountingClosingChar123IdChar125Route
  '/$commiteeSlug/accounting/parameters/account-periods': typeof CommiteeSlugAccountingParametersAccountPeriodsRoute
  '/$commiteeSlug/accounting/parameters/banks': typeof CommiteeSlugAccountingParametersBanksRoute
  '/$commiteeSlug/accounting/transactions/{-$id}': typeof CommiteeSlugAccountingTransactionsChar123IdChar125Route
  '/$commiteeSlug/beneficiaries/employees-beneficiaries/{-$id}': typeof CommiteeSlugBeneficiariesEmployeesBeneficiariesChar123IdChar125Route
  '/$commiteeSlug/beneficiaries/employees/{-$id}': typeof CommiteeSlugBeneficiariesEmployeesChar123IdChar125Route
  '/$commiteeSlug/beneficiaries/transactions/{-$id}': typeof CommiteeSlugBeneficiariesTransactionsChar123IdChar125Route
  '/$commiteeSlug/treasury/bank-deposits/$depositSlipNumber': typeof CommiteeSlugTreasuryBankDepositsDepositSlipNumberRoute
  '/gestion/entreprise/$id/banque': typeof GestionEntrepriseIdBanqueRoute
  '/gestion/entreprise/$id/lieu-de-travail': typeof GestionEntrepriseIdLieuDeTravailRoute
  '/gestion/entreprise/$id/users': typeof GestionEntrepriseIdUsersRoute
  '/$commiteeSlug/accounting/fec/': typeof CommiteeSlugAccountingFecIndexRoute
  '/$commiteeSlug/accounting/parameters/': typeof CommiteeSlugAccountingParametersIndexRoute
  '/$commiteeSlug/accounting/reports/': typeof CommiteeSlugAccountingReportsIndexRoute
  '/$commiteeSlug/beneficiaries/billetterie-orders/': typeof CommiteeSlugBeneficiariesBilletterieOrdersIndexRoute
  '/$commiteeSlug/beneficiaries/debts/': typeof CommiteeSlugBeneficiariesDebtsIndexRoute
  '/$commiteeSlug/treasury/bank-deposits/': typeof CommiteeSlugTreasuryBankDepositsIndexRoute
  '/gestion/entreprise/$id/': typeof GestionEntrepriseIdIndexRoute
  '/$commiteeSlug/accounting/parameters/financial-accounts/{-$id}': typeof CommiteeSlugAccountingParametersFinancialAccountsChar123IdChar125Route
  '/$commiteeSlug/accounting/parameters/journals/{-$id}': typeof CommiteeSlugAccountingParametersJournalsChar123IdChar125Route
  '/$commiteeSlug/accounting/parameters/transaction-categories/{-$id}': typeof CommiteeSlugAccountingParametersTransactionCategoriesChar123IdChar125Route
  '/$commiteeSlug/suppliers/$supplierId/orders/create': typeof CommiteeSlugSuppliersSupplierIdOrdersCreateRoute
  '/$commiteeSlug/suppliers/$supplierId/payments/create': typeof CommiteeSlugSuppliersSupplierIdPaymentsCreateRoute
  '/$commiteeSlug/accounting/parameters/transaction-models/': typeof CommiteeSlugAccountingParametersTransactionModelsIndexRoute
  '/$commiteeSlug/beneficiaries/transactions/create/': typeof CommiteeSlugBeneficiariesTransactionsCreateIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/account/banque': typeof AccountBanqueRoute
  '/account/details': typeof AccountDetailsRoute
  '/account/entreprise': typeof AccountEntrepriseRoute
  '/account/users': typeof AccountUsersRoute
  '/gestion/create': typeof GestionCreateRoute
  '/gestion/general': typeof GestionGeneralRoute
  '/$commiteeSlug': typeof CommiteeSlugIndexRoute
  '/$commiteeSlug/account/details': typeof CommiteeSlugAccountDetailsRoute
  '/$commiteeSlug/credit-notes/create': typeof CommiteeSlugCreditNotesCreateRoute
  '/$commiteeSlug/immobilisations/create': typeof CommiteeSlugImmobilisationsCreateRoute
  '/$commiteeSlug/immobilisations/{-$id}': typeof CommiteeSlugImmobilisationsChar123IdChar125Route
  '/$commiteeSlug/invoices/$invoiceId': typeof CommiteeSlugInvoicesInvoiceIdRoute
  '/$commiteeSlug/orders/$orderId': typeof CommiteeSlugOrdersOrderIdRoute
  '/$commiteeSlug/orders/create': typeof CommiteeSlugOrdersCreateRoute
  '/$commiteeSlug/prestation-participations/create': typeof CommiteeSlugPrestationParticipationsCreateRoute
  '/$commiteeSlug/prestation-participations/{-$id}': typeof CommiteeSlugPrestationParticipationsChar123IdChar125Route
  '/$commiteeSlug/prestation/create': typeof CommiteeSlugPrestationCreateRoute
  '/$commiteeSlug/prestation/{-$id}': typeof CommiteeSlugPrestationChar123IdChar125Route
  '/$commiteeSlug/suppliers/create': typeof CommiteeSlugSuppliersCreateRoute
  '/$commiteeSlug/suppliers/{-$id}': typeof CommiteeSlugSuppliersChar123IdChar125Route
  '/$commiteeSlug/treasury/cash-register': typeof CommiteeSlugTreasuryCashRegisterRoute
  '/$commiteeSlug/treasury/pending-disbursements': typeof CommiteeSlugTreasuryPendingDisbursementsRoute
  '/$commiteeSlug/treasury/pending-payments': typeof CommiteeSlugTreasuryPendingPaymentsRoute
  '/account/lieu-de-travail/$id': typeof AccountLieuDeTravailIdRoute
  '/$commiteeSlug/immobilisations': typeof CommiteeSlugImmobilisationsIndexRoute
  '/$commiteeSlug/inventory': typeof CommiteeSlugInventoryIndexRoute
  '/$commiteeSlug/invoices': typeof CommiteeSlugInvoicesIndexRoute
  '/$commiteeSlug/orders': typeof CommiteeSlugOrdersIndexRoute
  '/$commiteeSlug/prestation-participations': typeof CommiteeSlugPrestationParticipationsIndexRoute
  '/$commiteeSlug/prestation-rules': typeof CommiteeSlugPrestationRulesIndexRoute
  '/$commiteeSlug/prestation': typeof CommiteeSlugPrestationIndexRoute
  '/$commiteeSlug/suppliers': typeof CommiteeSlugSuppliersIndexRoute
  '/account/lieu-de-travail': typeof AccountLieuDeTravailIndexRoute
  '/$commiteeSlug/accounting/bank-reconciliations/creation': typeof CommiteeSlugAccountingBankReconciliationsCreationRoute
  '/$commiteeSlug/accounting/bank-reconciliations/{-$id}': typeof CommiteeSlugAccountingBankReconciliationsChar123IdChar125Route
  '/$commiteeSlug/accounting/closing/{-$id}': typeof CommiteeSlugAccountingClosingChar123IdChar125Route
  '/$commiteeSlug/accounting/parameters/account-periods': typeof CommiteeSlugAccountingParametersAccountPeriodsRoute
  '/$commiteeSlug/accounting/parameters/banks': typeof CommiteeSlugAccountingParametersBanksRoute
  '/$commiteeSlug/accounting/transactions/{-$id}': typeof CommiteeSlugAccountingTransactionsChar123IdChar125Route
  '/$commiteeSlug/beneficiaries/employees-beneficiaries/{-$id}': typeof CommiteeSlugBeneficiariesEmployeesBeneficiariesChar123IdChar125Route
  '/$commiteeSlug/beneficiaries/employees/{-$id}': typeof CommiteeSlugBeneficiariesEmployeesChar123IdChar125Route
  '/$commiteeSlug/beneficiaries/transactions/{-$id}': typeof CommiteeSlugBeneficiariesTransactionsChar123IdChar125Route
  '/$commiteeSlug/treasury/bank-deposits/$depositSlipNumber': typeof CommiteeSlugTreasuryBankDepositsDepositSlipNumberRoute
  '/gestion/entreprise/$id/banque': typeof GestionEntrepriseIdBanqueRoute
  '/gestion/entreprise/$id/lieu-de-travail': typeof GestionEntrepriseIdLieuDeTravailRoute
  '/gestion/entreprise/$id/users': typeof GestionEntrepriseIdUsersRoute
  '/$commiteeSlug/accounting/fec': typeof CommiteeSlugAccountingFecIndexRoute
  '/$commiteeSlug/accounting/parameters': typeof CommiteeSlugAccountingParametersIndexRoute
  '/$commiteeSlug/accounting/reports': typeof CommiteeSlugAccountingReportsIndexRoute
  '/$commiteeSlug/beneficiaries/billetterie-orders': typeof CommiteeSlugBeneficiariesBilletterieOrdersIndexRoute
  '/$commiteeSlug/beneficiaries/debts': typeof CommiteeSlugBeneficiariesDebtsIndexRoute
  '/$commiteeSlug/treasury/bank-deposits': typeof CommiteeSlugTreasuryBankDepositsIndexRoute
  '/gestion/entreprise/$id': typeof GestionEntrepriseIdIndexRoute
  '/$commiteeSlug/accounting/parameters/financial-accounts/{-$id}': typeof CommiteeSlugAccountingParametersFinancialAccountsChar123IdChar125Route
  '/$commiteeSlug/accounting/parameters/journals/{-$id}': typeof CommiteeSlugAccountingParametersJournalsChar123IdChar125Route
  '/$commiteeSlug/accounting/parameters/transaction-categories/{-$id}': typeof CommiteeSlugAccountingParametersTransactionCategoriesChar123IdChar125Route
  '/$commiteeSlug/suppliers/$supplierId/orders/create': typeof CommiteeSlugSuppliersSupplierIdOrdersCreateRoute
  '/$commiteeSlug/suppliers/$supplierId/payments/create': typeof CommiteeSlugSuppliersSupplierIdPaymentsCreateRoute
  '/$commiteeSlug/accounting/parameters/transaction-models': typeof CommiteeSlugAccountingParametersTransactionModelsIndexRoute
  '/$commiteeSlug/beneficiaries/transactions/create': typeof CommiteeSlugBeneficiariesTransactionsCreateIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$commiteeSlug': typeof CommiteeSlugRouteWithChildren
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/account/banque': typeof AccountBanqueRoute
  '/account/details': typeof AccountDetailsRoute
  '/account/entreprise': typeof AccountEntrepriseRoute
  '/account/lieu-de-travail': typeof AccountLieuDeTravailRouteWithChildren
  '/account/users': typeof AccountUsersRoute
  '/gestion/create': typeof GestionCreateRoute
  '/gestion/general': typeof GestionGeneralRoute
  '/$commiteeSlug/': typeof CommiteeSlugIndexRoute
  '/$commiteeSlug/account/details': typeof CommiteeSlugAccountDetailsRoute
  '/$commiteeSlug/credit-notes/create': typeof CommiteeSlugCreditNotesCreateRoute
  '/$commiteeSlug/immobilisations/create': typeof CommiteeSlugImmobilisationsCreateRoute
  '/$commiteeSlug/immobilisations/{-$id}': typeof CommiteeSlugImmobilisationsChar123IdChar125Route
  '/$commiteeSlug/invoices/$invoiceId': typeof CommiteeSlugInvoicesInvoiceIdRoute
  '/$commiteeSlug/orders/$orderId': typeof CommiteeSlugOrdersOrderIdRoute
  '/$commiteeSlug/orders/create': typeof CommiteeSlugOrdersCreateRoute
  '/$commiteeSlug/prestation-participations/create': typeof CommiteeSlugPrestationParticipationsCreateRoute
  '/$commiteeSlug/prestation-participations/{-$id}': typeof CommiteeSlugPrestationParticipationsChar123IdChar125Route
  '/$commiteeSlug/prestation/create': typeof CommiteeSlugPrestationCreateRoute
  '/$commiteeSlug/prestation/{-$id}': typeof CommiteeSlugPrestationChar123IdChar125Route
  '/$commiteeSlug/suppliers/create': typeof CommiteeSlugSuppliersCreateRoute
  '/$commiteeSlug/suppliers/{-$id}': typeof CommiteeSlugSuppliersChar123IdChar125Route
  '/$commiteeSlug/treasury/cash-register': typeof CommiteeSlugTreasuryCashRegisterRoute
  '/$commiteeSlug/treasury/pending-disbursements': typeof CommiteeSlugTreasuryPendingDisbursementsRoute
  '/$commiteeSlug/treasury/pending-payments': typeof CommiteeSlugTreasuryPendingPaymentsRoute
  '/account/lieu-de-travail/$id': typeof AccountLieuDeTravailIdRoute
  '/gestion/entreprise/$id': typeof GestionEntrepriseIdRouteWithChildren
  '/$commiteeSlug/immobilisations/': typeof CommiteeSlugImmobilisationsIndexRoute
  '/$commiteeSlug/inventory/': typeof CommiteeSlugInventoryIndexRoute
  '/$commiteeSlug/invoices/': typeof CommiteeSlugInvoicesIndexRoute
  '/$commiteeSlug/orders/': typeof CommiteeSlugOrdersIndexRoute
  '/$commiteeSlug/prestation-participations/': typeof CommiteeSlugPrestationParticipationsIndexRoute
  '/$commiteeSlug/prestation-rules/': typeof CommiteeSlugPrestationRulesIndexRoute
  '/$commiteeSlug/prestation/': typeof CommiteeSlugPrestationIndexRoute
  '/$commiteeSlug/suppliers/': typeof CommiteeSlugSuppliersIndexRoute
  '/account/lieu-de-travail/': typeof AccountLieuDeTravailIndexRoute
  '/$commiteeSlug/accounting/bank-reconciliations/creation': typeof CommiteeSlugAccountingBankReconciliationsCreationRoute
  '/$commiteeSlug/accounting/bank-reconciliations/{-$id}': typeof CommiteeSlugAccountingBankReconciliationsChar123IdChar125Route
  '/$commiteeSlug/accounting/closing/{-$id}': typeof CommiteeSlugAccountingClosingChar123IdChar125Route
  '/$commiteeSlug/accounting/parameters/account-periods': typeof CommiteeSlugAccountingParametersAccountPeriodsRoute
  '/$commiteeSlug/accounting/parameters/banks': typeof CommiteeSlugAccountingParametersBanksRoute
  '/$commiteeSlug/accounting/transactions/{-$id}': typeof CommiteeSlugAccountingTransactionsChar123IdChar125Route
  '/$commiteeSlug/beneficiaries/employees-beneficiaries/{-$id}': typeof CommiteeSlugBeneficiariesEmployeesBeneficiariesChar123IdChar125Route
  '/$commiteeSlug/beneficiaries/employees/{-$id}': typeof CommiteeSlugBeneficiariesEmployeesChar123IdChar125Route
  '/$commiteeSlug/beneficiaries/transactions/{-$id}': typeof CommiteeSlugBeneficiariesTransactionsChar123IdChar125Route
  '/$commiteeSlug/treasury/bank-deposits/$depositSlipNumber': typeof CommiteeSlugTreasuryBankDepositsDepositSlipNumberRoute
  '/gestion/entreprise/$id/banque': typeof GestionEntrepriseIdBanqueRoute
  '/gestion/entreprise/$id/lieu-de-travail': typeof GestionEntrepriseIdLieuDeTravailRoute
  '/gestion/entreprise/$id/users': typeof GestionEntrepriseIdUsersRoute
  '/$commiteeSlug/accounting/fec/': typeof CommiteeSlugAccountingFecIndexRoute
  '/$commiteeSlug/accounting/parameters/': typeof CommiteeSlugAccountingParametersIndexRoute
  '/$commiteeSlug/accounting/reports/': typeof CommiteeSlugAccountingReportsIndexRoute
  '/$commiteeSlug/beneficiaries/billetterie-orders/': typeof CommiteeSlugBeneficiariesBilletterieOrdersIndexRoute
  '/$commiteeSlug/beneficiaries/debts/': typeof CommiteeSlugBeneficiariesDebtsIndexRoute
  '/$commiteeSlug/treasury/bank-deposits/': typeof CommiteeSlugTreasuryBankDepositsIndexRoute
  '/gestion/entreprise/$id/': typeof GestionEntrepriseIdIndexRoute
  '/$commiteeSlug/accounting/parameters/financial-accounts/{-$id}': typeof CommiteeSlugAccountingParametersFinancialAccountsChar123IdChar125Route
  '/$commiteeSlug/accounting/parameters/journals/{-$id}': typeof CommiteeSlugAccountingParametersJournalsChar123IdChar125Route
  '/$commiteeSlug/accounting/parameters/transaction-categories/{-$id}': typeof CommiteeSlugAccountingParametersTransactionCategoriesChar123IdChar125Route
  '/$commiteeSlug/suppliers/$supplierId/orders/create': typeof CommiteeSlugSuppliersSupplierIdOrdersCreateRoute
  '/$commiteeSlug/suppliers/$supplierId/payments/create': typeof CommiteeSlugSuppliersSupplierIdPaymentsCreateRoute
  '/$commiteeSlug/accounting/parameters/transaction-models/': typeof CommiteeSlugAccountingParametersTransactionModelsIndexRoute
  '/$commiteeSlug/beneficiaries/transactions/create/': typeof CommiteeSlugBeneficiariesTransactionsCreateIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$commiteeSlug'
    | '/login'
    | '/reset-password'
    | '/account/banque'
    | '/account/details'
    | '/account/entreprise'
    | '/account/lieu-de-travail'
    | '/account/users'
    | '/gestion/create'
    | '/gestion/general'
    | '/$commiteeSlug/'
    | '/$commiteeSlug/account/details'
    | '/$commiteeSlug/credit-notes/create'
    | '/$commiteeSlug/immobilisations/create'
    | '/$commiteeSlug/immobilisations/{-$id}'
    | '/$commiteeSlug/invoices/$invoiceId'
    | '/$commiteeSlug/orders/$orderId'
    | '/$commiteeSlug/orders/create'
    | '/$commiteeSlug/prestation-participations/create'
    | '/$commiteeSlug/prestation-participations/{-$id}'
    | '/$commiteeSlug/prestation/create'
    | '/$commiteeSlug/prestation/{-$id}'
    | '/$commiteeSlug/suppliers/create'
    | '/$commiteeSlug/suppliers/{-$id}'
    | '/$commiteeSlug/treasury/cash-register'
    | '/$commiteeSlug/treasury/pending-disbursements'
    | '/$commiteeSlug/treasury/pending-payments'
    | '/account/lieu-de-travail/$id'
    | '/gestion/entreprise/$id'
    | '/$commiteeSlug/immobilisations/'
    | '/$commiteeSlug/inventory/'
    | '/$commiteeSlug/invoices/'
    | '/$commiteeSlug/orders/'
    | '/$commiteeSlug/prestation-participations/'
    | '/$commiteeSlug/prestation-rules/'
    | '/$commiteeSlug/prestation/'
    | '/$commiteeSlug/suppliers/'
    | '/account/lieu-de-travail/'
    | '/$commiteeSlug/accounting/bank-reconciliations/creation'
    | '/$commiteeSlug/accounting/bank-reconciliations/{-$id}'
    | '/$commiteeSlug/accounting/closing/{-$id}'
    | '/$commiteeSlug/accounting/parameters/account-periods'
    | '/$commiteeSlug/accounting/parameters/banks'
    | '/$commiteeSlug/accounting/transactions/{-$id}'
    | '/$commiteeSlug/beneficiaries/employees-beneficiaries/{-$id}'
    | '/$commiteeSlug/beneficiaries/employees/{-$id}'
    | '/$commiteeSlug/beneficiaries/transactions/{-$id}'
    | '/$commiteeSlug/treasury/bank-deposits/$depositSlipNumber'
    | '/gestion/entreprise/$id/banque'
    | '/gestion/entreprise/$id/lieu-de-travail'
    | '/gestion/entreprise/$id/users'
    | '/$commiteeSlug/accounting/fec/'
    | '/$commiteeSlug/accounting/parameters/'
    | '/$commiteeSlug/accounting/reports/'
    | '/$commiteeSlug/beneficiaries/billetterie-orders/'
    | '/$commiteeSlug/beneficiaries/debts/'
    | '/$commiteeSlug/treasury/bank-deposits/'
    | '/gestion/entreprise/$id/'
    | '/$commiteeSlug/accounting/parameters/financial-accounts/{-$id}'
    | '/$commiteeSlug/accounting/parameters/journals/{-$id}'
    | '/$commiteeSlug/accounting/parameters/transaction-categories/{-$id}'
    | '/$commiteeSlug/suppliers/$supplierId/orders/create'
    | '/$commiteeSlug/suppliers/$supplierId/payments/create'
    | '/$commiteeSlug/accounting/parameters/transaction-models/'
    | '/$commiteeSlug/beneficiaries/transactions/create/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/reset-password'
    | '/account/banque'
    | '/account/details'
    | '/account/entreprise'
    | '/account/users'
    | '/gestion/create'
    | '/gestion/general'
    | '/$commiteeSlug'
    | '/$commiteeSlug/account/details'
    | '/$commiteeSlug/credit-notes/create'
    | '/$commiteeSlug/immobilisations/create'
    | '/$commiteeSlug/immobilisations/{-$id}'
    | '/$commiteeSlug/invoices/$invoiceId'
    | '/$commiteeSlug/orders/$orderId'
    | '/$commiteeSlug/orders/create'
    | '/$commiteeSlug/prestation-participations/create'
    | '/$commiteeSlug/prestation-participations/{-$id}'
    | '/$commiteeSlug/prestation/create'
    | '/$commiteeSlug/prestation/{-$id}'
    | '/$commiteeSlug/suppliers/create'
    | '/$commiteeSlug/suppliers/{-$id}'
    | '/$commiteeSlug/treasury/cash-register'
    | '/$commiteeSlug/treasury/pending-disbursements'
    | '/$commiteeSlug/treasury/pending-payments'
    | '/account/lieu-de-travail/$id'
    | '/$commiteeSlug/immobilisations'
    | '/$commiteeSlug/inventory'
    | '/$commiteeSlug/invoices'
    | '/$commiteeSlug/orders'
    | '/$commiteeSlug/prestation-participations'
    | '/$commiteeSlug/prestation-rules'
    | '/$commiteeSlug/prestation'
    | '/$commiteeSlug/suppliers'
    | '/account/lieu-de-travail'
    | '/$commiteeSlug/accounting/bank-reconciliations/creation'
    | '/$commiteeSlug/accounting/bank-reconciliations/{-$id}'
    | '/$commiteeSlug/accounting/closing/{-$id}'
    | '/$commiteeSlug/accounting/parameters/account-periods'
    | '/$commiteeSlug/accounting/parameters/banks'
    | '/$commiteeSlug/accounting/transactions/{-$id}'
    | '/$commiteeSlug/beneficiaries/employees-beneficiaries/{-$id}'
    | '/$commiteeSlug/beneficiaries/employees/{-$id}'
    | '/$commiteeSlug/beneficiaries/transactions/{-$id}'
    | '/$commiteeSlug/treasury/bank-deposits/$depositSlipNumber'
    | '/gestion/entreprise/$id/banque'
    | '/gestion/entreprise/$id/lieu-de-travail'
    | '/gestion/entreprise/$id/users'
    | '/$commiteeSlug/accounting/fec'
    | '/$commiteeSlug/accounting/parameters'
    | '/$commiteeSlug/accounting/reports'
    | '/$commiteeSlug/beneficiaries/billetterie-orders'
    | '/$commiteeSlug/beneficiaries/debts'
    | '/$commiteeSlug/treasury/bank-deposits'
    | '/gestion/entreprise/$id'
    | '/$commiteeSlug/accounting/parameters/financial-accounts/{-$id}'
    | '/$commiteeSlug/accounting/parameters/journals/{-$id}'
    | '/$commiteeSlug/accounting/parameters/transaction-categories/{-$id}'
    | '/$commiteeSlug/suppliers/$supplierId/orders/create'
    | '/$commiteeSlug/suppliers/$supplierId/payments/create'
    | '/$commiteeSlug/accounting/parameters/transaction-models'
    | '/$commiteeSlug/beneficiaries/transactions/create'
  id:
    | '__root__'
    | '/$commiteeSlug'
    | '/login'
    | '/reset-password'
    | '/account/banque'
    | '/account/details'
    | '/account/entreprise'
    | '/account/lieu-de-travail'
    | '/account/users'
    | '/gestion/create'
    | '/gestion/general'
    | '/$commiteeSlug/'
    | '/$commiteeSlug/account/details'
    | '/$commiteeSlug/credit-notes/create'
    | '/$commiteeSlug/immobilisations/create'
    | '/$commiteeSlug/immobilisations/{-$id}'
    | '/$commiteeSlug/invoices/$invoiceId'
    | '/$commiteeSlug/orders/$orderId'
    | '/$commiteeSlug/orders/create'
    | '/$commiteeSlug/prestation-participations/create'
    | '/$commiteeSlug/prestation-participations/{-$id}'
    | '/$commiteeSlug/prestation/create'
    | '/$commiteeSlug/prestation/{-$id}'
    | '/$commiteeSlug/suppliers/create'
    | '/$commiteeSlug/suppliers/{-$id}'
    | '/$commiteeSlug/treasury/cash-register'
    | '/$commiteeSlug/treasury/pending-disbursements'
    | '/$commiteeSlug/treasury/pending-payments'
    | '/account/lieu-de-travail/$id'
    | '/gestion/entreprise/$id'
    | '/$commiteeSlug/immobilisations/'
    | '/$commiteeSlug/inventory/'
    | '/$commiteeSlug/invoices/'
    | '/$commiteeSlug/orders/'
    | '/$commiteeSlug/prestation-participations/'
    | '/$commiteeSlug/prestation-rules/'
    | '/$commiteeSlug/prestation/'
    | '/$commiteeSlug/suppliers/'
    | '/account/lieu-de-travail/'
    | '/$commiteeSlug/accounting/bank-reconciliations/creation'
    | '/$commiteeSlug/accounting/bank-reconciliations/{-$id}'
    | '/$commiteeSlug/accounting/closing/{-$id}'
    | '/$commiteeSlug/accounting/parameters/account-periods'
    | '/$commiteeSlug/accounting/parameters/banks'
    | '/$commiteeSlug/accounting/transactions/{-$id}'
    | '/$commiteeSlug/beneficiaries/employees-beneficiaries/{-$id}'
    | '/$commiteeSlug/beneficiaries/employees/{-$id}'
    | '/$commiteeSlug/beneficiaries/transactions/{-$id}'
    | '/$commiteeSlug/treasury/bank-deposits/$depositSlipNumber'
    | '/gestion/entreprise/$id/banque'
    | '/gestion/entreprise/$id/lieu-de-travail'
    | '/gestion/entreprise/$id/users'
    | '/$commiteeSlug/accounting/fec/'
    | '/$commiteeSlug/accounting/parameters/'
    | '/$commiteeSlug/accounting/reports/'
    | '/$commiteeSlug/beneficiaries/billetterie-orders/'
    | '/$commiteeSlug/beneficiaries/debts/'
    | '/$commiteeSlug/treasury/bank-deposits/'
    | '/gestion/entreprise/$id/'
    | '/$commiteeSlug/accounting/parameters/financial-accounts/{-$id}'
    | '/$commiteeSlug/accounting/parameters/journals/{-$id}'
    | '/$commiteeSlug/accounting/parameters/transaction-categories/{-$id}'
    | '/$commiteeSlug/suppliers/$supplierId/orders/create'
    | '/$commiteeSlug/suppliers/$supplierId/payments/create'
    | '/$commiteeSlug/accounting/parameters/transaction-models/'
    | '/$commiteeSlug/beneficiaries/transactions/create/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  CommiteeSlugRoute: typeof CommiteeSlugRouteWithChildren
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  AccountBanqueRoute: typeof AccountBanqueRoute
  AccountDetailsRoute: typeof AccountDetailsRoute
  AccountEntrepriseRoute: typeof AccountEntrepriseRoute
  AccountLieuDeTravailRoute: typeof AccountLieuDeTravailRouteWithChildren
  AccountUsersRoute: typeof AccountUsersRoute
  GestionCreateRoute: typeof GestionCreateRoute
  GestionGeneralRoute: typeof GestionGeneralRoute
  GestionEntrepriseIdRoute: typeof GestionEntrepriseIdRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$commiteeSlug': {
      id: '/$commiteeSlug'
      path: '/$commiteeSlug'
      fullPath: '/$commiteeSlug'
      preLoaderRoute: typeof CommiteeSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$commiteeSlug/': {
      id: '/$commiteeSlug/'
      path: '/'
      fullPath: '/$commiteeSlug/'
      preLoaderRoute: typeof CommiteeSlugIndexRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/account/banque': {
      id: '/account/banque'
      path: '/account/banque'
      fullPath: '/account/banque'
      preLoaderRoute: typeof AccountBanqueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/details': {
      id: '/account/details'
      path: '/account/details'
      fullPath: '/account/details'
      preLoaderRoute: typeof AccountDetailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/entreprise': {
      id: '/account/entreprise'
      path: '/account/entreprise'
      fullPath: '/account/entreprise'
      preLoaderRoute: typeof AccountEntrepriseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/lieu-de-travail': {
      id: '/account/lieu-de-travail'
      path: '/account/lieu-de-travail'
      fullPath: '/account/lieu-de-travail'
      preLoaderRoute: typeof AccountLieuDeTravailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/users': {
      id: '/account/users'
      path: '/account/users'
      fullPath: '/account/users'
      preLoaderRoute: typeof AccountUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gestion/create': {
      id: '/gestion/create'
      path: '/gestion/create'
      fullPath: '/gestion/create'
      preLoaderRoute: typeof GestionCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gestion/general': {
      id: '/gestion/general'
      path: '/gestion/general'
      fullPath: '/gestion/general'
      preLoaderRoute: typeof GestionGeneralRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$commiteeSlug/account/details': {
      id: '/$commiteeSlug/account/details'
      path: '/account/details'
      fullPath: '/$commiteeSlug/account/details'
      preLoaderRoute: typeof CommiteeSlugAccountDetailsRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/credit-notes/create': {
      id: '/$commiteeSlug/credit-notes/create'
      path: '/credit-notes/create'
      fullPath: '/$commiteeSlug/credit-notes/create'
      preLoaderRoute: typeof CommiteeSlugCreditNotesCreateRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/immobilisations/': {
      id: '/$commiteeSlug/immobilisations/'
      path: '/immobilisations'
      fullPath: '/$commiteeSlug/immobilisations/'
      preLoaderRoute: typeof CommiteeSlugImmobilisationsIndexRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/immobilisations/create': {
      id: '/$commiteeSlug/immobilisations/create'
      path: '/immobilisations/create'
      fullPath: '/$commiteeSlug/immobilisations/create'
      preLoaderRoute: typeof CommiteeSlugImmobilisationsCreateRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/immobilisations/{-$id}': {
      id: '/$commiteeSlug/immobilisations/{-$id}'
      path: '/immobilisations/{-$id}'
      fullPath: '/$commiteeSlug/immobilisations/{-$id}'
      preLoaderRoute: typeof CommiteeSlugImmobilisationsChar123IdChar125RouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/inventory/': {
      id: '/$commiteeSlug/inventory/'
      path: '/inventory'
      fullPath: '/$commiteeSlug/inventory/'
      preLoaderRoute: typeof CommiteeSlugInventoryIndexRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/invoices/': {
      id: '/$commiteeSlug/invoices/'
      path: '/invoices'
      fullPath: '/$commiteeSlug/invoices/'
      preLoaderRoute: typeof CommiteeSlugInvoicesIndexRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/invoices/$invoiceId': {
      id: '/$commiteeSlug/invoices/$invoiceId'
      path: '/invoices/$invoiceId'
      fullPath: '/$commiteeSlug/invoices/$invoiceId'
      preLoaderRoute: typeof CommiteeSlugInvoicesInvoiceIdRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/orders/': {
      id: '/$commiteeSlug/orders/'
      path: '/orders'
      fullPath: '/$commiteeSlug/orders/'
      preLoaderRoute: typeof CommiteeSlugOrdersIndexRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/orders/$orderId': {
      id: '/$commiteeSlug/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/$commiteeSlug/orders/$orderId'
      preLoaderRoute: typeof CommiteeSlugOrdersOrderIdRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/orders/create': {
      id: '/$commiteeSlug/orders/create'
      path: '/orders/create'
      fullPath: '/$commiteeSlug/orders/create'
      preLoaderRoute: typeof CommiteeSlugOrdersCreateRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/prestation-participations/': {
      id: '/$commiteeSlug/prestation-participations/'
      path: '/prestation-participations'
      fullPath: '/$commiteeSlug/prestation-participations/'
      preLoaderRoute: typeof CommiteeSlugPrestationParticipationsIndexRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/prestation-participations/create': {
      id: '/$commiteeSlug/prestation-participations/create'
      path: '/prestation-participations/create'
      fullPath: '/$commiteeSlug/prestation-participations/create'
      preLoaderRoute: typeof CommiteeSlugPrestationParticipationsCreateRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/prestation-participations/{-$id}': {
      id: '/$commiteeSlug/prestation-participations/{-$id}'
      path: '/prestation-participations/{-$id}'
      fullPath: '/$commiteeSlug/prestation-participations/{-$id}'
      preLoaderRoute: typeof CommiteeSlugPrestationParticipationsChar123IdChar125RouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/prestation-rules/': {
      id: '/$commiteeSlug/prestation-rules/'
      path: '/prestation-rules'
      fullPath: '/$commiteeSlug/prestation-rules/'
      preLoaderRoute: typeof CommiteeSlugPrestationRulesIndexRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/prestation/': {
      id: '/$commiteeSlug/prestation/'
      path: '/prestation'
      fullPath: '/$commiteeSlug/prestation/'
      preLoaderRoute: typeof CommiteeSlugPrestationIndexRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/prestation/create': {
      id: '/$commiteeSlug/prestation/create'
      path: '/prestation/create'
      fullPath: '/$commiteeSlug/prestation/create'
      preLoaderRoute: typeof CommiteeSlugPrestationCreateRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/prestation/{-$id}': {
      id: '/$commiteeSlug/prestation/{-$id}'
      path: '/prestation/{-$id}'
      fullPath: '/$commiteeSlug/prestation/{-$id}'
      preLoaderRoute: typeof CommiteeSlugPrestationChar123IdChar125RouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/suppliers/': {
      id: '/$commiteeSlug/suppliers/'
      path: '/suppliers'
      fullPath: '/$commiteeSlug/suppliers/'
      preLoaderRoute: typeof CommiteeSlugSuppliersIndexRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/suppliers/create': {
      id: '/$commiteeSlug/suppliers/create'
      path: '/suppliers/create'
      fullPath: '/$commiteeSlug/suppliers/create'
      preLoaderRoute: typeof CommiteeSlugSuppliersCreateRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/suppliers/{-$id}': {
      id: '/$commiteeSlug/suppliers/{-$id}'
      path: '/suppliers/{-$id}'
      fullPath: '/$commiteeSlug/suppliers/{-$id}'
      preLoaderRoute: typeof CommiteeSlugSuppliersChar123IdChar125RouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/treasury/cash-register': {
      id: '/$commiteeSlug/treasury/cash-register'
      path: '/treasury/cash-register'
      fullPath: '/$commiteeSlug/treasury/cash-register'
      preLoaderRoute: typeof CommiteeSlugTreasuryCashRegisterRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/treasury/pending-disbursements': {
      id: '/$commiteeSlug/treasury/pending-disbursements'
      path: '/treasury/pending-disbursements'
      fullPath: '/$commiteeSlug/treasury/pending-disbursements'
      preLoaderRoute: typeof CommiteeSlugTreasuryPendingDisbursementsRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/treasury/pending-payments': {
      id: '/$commiteeSlug/treasury/pending-payments'
      path: '/treasury/pending-payments'
      fullPath: '/$commiteeSlug/treasury/pending-payments'
      preLoaderRoute: typeof CommiteeSlugTreasuryPendingPaymentsRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/account/lieu-de-travail/': {
      id: '/account/lieu-de-travail/'
      path: '/'
      fullPath: '/account/lieu-de-travail/'
      preLoaderRoute: typeof AccountLieuDeTravailIndexRouteImport
      parentRoute: typeof AccountLieuDeTravailRoute
    }
    '/account/lieu-de-travail/$id': {
      id: '/account/lieu-de-travail/$id'
      path: '/$id'
      fullPath: '/account/lieu-de-travail/$id'
      preLoaderRoute: typeof AccountLieuDeTravailIdRouteImport
      parentRoute: typeof AccountLieuDeTravailRoute
    }
    '/gestion/entreprise/$id': {
      id: '/gestion/entreprise/$id'
      path: '/gestion/entreprise/$id'
      fullPath: '/gestion/entreprise/$id'
      preLoaderRoute: typeof GestionEntrepriseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$commiteeSlug/accounting/bank-reconciliations/creation': {
      id: '/$commiteeSlug/accounting/bank-reconciliations/creation'
      path: '/accounting/bank-reconciliations/creation'
      fullPath: '/$commiteeSlug/accounting/bank-reconciliations/creation'
      preLoaderRoute: typeof CommiteeSlugAccountingBankReconciliationsCreationRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/accounting/bank-reconciliations/{-$id}': {
      id: '/$commiteeSlug/accounting/bank-reconciliations/{-$id}'
      path: '/accounting/bank-reconciliations/{-$id}'
      fullPath: '/$commiteeSlug/accounting/bank-reconciliations/{-$id}'
      preLoaderRoute: typeof CommiteeSlugAccountingBankReconciliationsChar123IdChar125RouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/accounting/closing/{-$id}': {
      id: '/$commiteeSlug/accounting/closing/{-$id}'
      path: '/accounting/closing/{-$id}'
      fullPath: '/$commiteeSlug/accounting/closing/{-$id}'
      preLoaderRoute: typeof CommiteeSlugAccountingClosingChar123IdChar125RouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/accounting/fec/': {
      id: '/$commiteeSlug/accounting/fec/'
      path: '/accounting/fec'
      fullPath: '/$commiteeSlug/accounting/fec/'
      preLoaderRoute: typeof CommiteeSlugAccountingFecIndexRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/accounting/parameters/': {
      id: '/$commiteeSlug/accounting/parameters/'
      path: '/accounting/parameters'
      fullPath: '/$commiteeSlug/accounting/parameters/'
      preLoaderRoute: typeof CommiteeSlugAccountingParametersIndexRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/accounting/parameters/account-periods': {
      id: '/$commiteeSlug/accounting/parameters/account-periods'
      path: '/accounting/parameters/account-periods'
      fullPath: '/$commiteeSlug/accounting/parameters/account-periods'
      preLoaderRoute: typeof CommiteeSlugAccountingParametersAccountPeriodsRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/accounting/parameters/banks': {
      id: '/$commiteeSlug/accounting/parameters/banks'
      path: '/accounting/parameters/banks'
      fullPath: '/$commiteeSlug/accounting/parameters/banks'
      preLoaderRoute: typeof CommiteeSlugAccountingParametersBanksRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/accounting/reports/': {
      id: '/$commiteeSlug/accounting/reports/'
      path: '/accounting/reports'
      fullPath: '/$commiteeSlug/accounting/reports/'
      preLoaderRoute: typeof CommiteeSlugAccountingReportsIndexRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/accounting/transactions/{-$id}': {
      id: '/$commiteeSlug/accounting/transactions/{-$id}'
      path: '/accounting/transactions/{-$id}'
      fullPath: '/$commiteeSlug/accounting/transactions/{-$id}'
      preLoaderRoute: typeof CommiteeSlugAccountingTransactionsChar123IdChar125RouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/beneficiaries/billetterie-orders/': {
      id: '/$commiteeSlug/beneficiaries/billetterie-orders/'
      path: '/beneficiaries/billetterie-orders'
      fullPath: '/$commiteeSlug/beneficiaries/billetterie-orders/'
      preLoaderRoute: typeof CommiteeSlugBeneficiariesBilletterieOrdersIndexRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/beneficiaries/debts/': {
      id: '/$commiteeSlug/beneficiaries/debts/'
      path: '/beneficiaries/debts'
      fullPath: '/$commiteeSlug/beneficiaries/debts/'
      preLoaderRoute: typeof CommiteeSlugBeneficiariesDebtsIndexRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/beneficiaries/employees-beneficiaries/{-$id}': {
      id: '/$commiteeSlug/beneficiaries/employees-beneficiaries/{-$id}'
      path: '/beneficiaries/employees-beneficiaries/{-$id}'
      fullPath: '/$commiteeSlug/beneficiaries/employees-beneficiaries/{-$id}'
      preLoaderRoute: typeof CommiteeSlugBeneficiariesEmployeesBeneficiariesChar123IdChar125RouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/beneficiaries/employees/{-$id}': {
      id: '/$commiteeSlug/beneficiaries/employees/{-$id}'
      path: '/beneficiaries/employees/{-$id}'
      fullPath: '/$commiteeSlug/beneficiaries/employees/{-$id}'
      preLoaderRoute: typeof CommiteeSlugBeneficiariesEmployeesChar123IdChar125RouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/beneficiaries/transactions/{-$id}': {
      id: '/$commiteeSlug/beneficiaries/transactions/{-$id}'
      path: '/beneficiaries/transactions/{-$id}'
      fullPath: '/$commiteeSlug/beneficiaries/transactions/{-$id}'
      preLoaderRoute: typeof CommiteeSlugBeneficiariesTransactionsChar123IdChar125RouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/treasury/bank-deposits/': {
      id: '/$commiteeSlug/treasury/bank-deposits/'
      path: '/treasury/bank-deposits'
      fullPath: '/$commiteeSlug/treasury/bank-deposits/'
      preLoaderRoute: typeof CommiteeSlugTreasuryBankDepositsIndexRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/treasury/bank-deposits/$depositSlipNumber': {
      id: '/$commiteeSlug/treasury/bank-deposits/$depositSlipNumber'
      path: '/treasury/bank-deposits/$depositSlipNumber'
      fullPath: '/$commiteeSlug/treasury/bank-deposits/$depositSlipNumber'
      preLoaderRoute: typeof CommiteeSlugTreasuryBankDepositsDepositSlipNumberRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/gestion/entreprise/$id/': {
      id: '/gestion/entreprise/$id/'
      path: '/'
      fullPath: '/gestion/entreprise/$id/'
      preLoaderRoute: typeof GestionEntrepriseIdIndexRouteImport
      parentRoute: typeof GestionEntrepriseIdRoute
    }
    '/gestion/entreprise/$id/banque': {
      id: '/gestion/entreprise/$id/banque'
      path: '/banque'
      fullPath: '/gestion/entreprise/$id/banque'
      preLoaderRoute: typeof GestionEntrepriseIdBanqueRouteImport
      parentRoute: typeof GestionEntrepriseIdRoute
    }
    '/gestion/entreprise/$id/lieu-de-travail': {
      id: '/gestion/entreprise/$id/lieu-de-travail'
      path: '/lieu-de-travail'
      fullPath: '/gestion/entreprise/$id/lieu-de-travail'
      preLoaderRoute: typeof GestionEntrepriseIdLieuDeTravailRouteImport
      parentRoute: typeof GestionEntrepriseIdRoute
    }
    '/gestion/entreprise/$id/users': {
      id: '/gestion/entreprise/$id/users'
      path: '/users'
      fullPath: '/gestion/entreprise/$id/users'
      preLoaderRoute: typeof GestionEntrepriseIdUsersRouteImport
      parentRoute: typeof GestionEntrepriseIdRoute
    }
    '/$commiteeSlug/accounting/parameters/financial-accounts/{-$id}': {
      id: '/$commiteeSlug/accounting/parameters/financial-accounts/{-$id}'
      path: '/accounting/parameters/financial-accounts/{-$id}'
      fullPath: '/$commiteeSlug/accounting/parameters/financial-accounts/{-$id}'
      preLoaderRoute: typeof CommiteeSlugAccountingParametersFinancialAccountsChar123IdChar125RouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/accounting/parameters/journals/{-$id}': {
      id: '/$commiteeSlug/accounting/parameters/journals/{-$id}'
      path: '/accounting/parameters/journals/{-$id}'
      fullPath: '/$commiteeSlug/accounting/parameters/journals/{-$id}'
      preLoaderRoute: typeof CommiteeSlugAccountingParametersJournalsChar123IdChar125RouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/accounting/parameters/transaction-categories/{-$id}': {
      id: '/$commiteeSlug/accounting/parameters/transaction-categories/{-$id}'
      path: '/accounting/parameters/transaction-categories/{-$id}'
      fullPath: '/$commiteeSlug/accounting/parameters/transaction-categories/{-$id}'
      preLoaderRoute: typeof CommiteeSlugAccountingParametersTransactionCategoriesChar123IdChar125RouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/accounting/parameters/transaction-models/': {
      id: '/$commiteeSlug/accounting/parameters/transaction-models/'
      path: '/accounting/parameters/transaction-models'
      fullPath: '/$commiteeSlug/accounting/parameters/transaction-models/'
      preLoaderRoute: typeof CommiteeSlugAccountingParametersTransactionModelsIndexRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/beneficiaries/transactions/create/': {
      id: '/$commiteeSlug/beneficiaries/transactions/create/'
      path: '/beneficiaries/transactions/create'
      fullPath: '/$commiteeSlug/beneficiaries/transactions/create/'
      preLoaderRoute: typeof CommiteeSlugBeneficiariesTransactionsCreateIndexRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/suppliers/$supplierId/orders/create': {
      id: '/$commiteeSlug/suppliers/$supplierId/orders/create'
      path: '/suppliers/$supplierId/orders/create'
      fullPath: '/$commiteeSlug/suppliers/$supplierId/orders/create'
      preLoaderRoute: typeof CommiteeSlugSuppliersSupplierIdOrdersCreateRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
    '/$commiteeSlug/suppliers/$supplierId/payments/create': {
      id: '/$commiteeSlug/suppliers/$supplierId/payments/create'
      path: '/suppliers/$supplierId/payments/create'
      fullPath: '/$commiteeSlug/suppliers/$supplierId/payments/create'
      preLoaderRoute: typeof CommiteeSlugSuppliersSupplierIdPaymentsCreateRouteImport
      parentRoute: typeof CommiteeSlugRoute
    }
  }
}

interface CommiteeSlugRouteChildren {
  CommiteeSlugIndexRoute: typeof CommiteeSlugIndexRoute
  CommiteeSlugAccountDetailsRoute: typeof CommiteeSlugAccountDetailsRoute
  CommiteeSlugCreditNotesCreateRoute: typeof CommiteeSlugCreditNotesCreateRoute
  CommiteeSlugImmobilisationsCreateRoute: typeof CommiteeSlugImmobilisationsCreateRoute
  CommiteeSlugImmobilisationsChar123IdChar125Route: typeof CommiteeSlugImmobilisationsChar123IdChar125Route
  CommiteeSlugInvoicesInvoiceIdRoute: typeof CommiteeSlugInvoicesInvoiceIdRoute
  CommiteeSlugOrdersOrderIdRoute: typeof CommiteeSlugOrdersOrderIdRoute
  CommiteeSlugOrdersCreateRoute: typeof CommiteeSlugOrdersCreateRoute
  CommiteeSlugPrestationParticipationsCreateRoute: typeof CommiteeSlugPrestationParticipationsCreateRoute
  CommiteeSlugPrestationParticipationsChar123IdChar125Route: typeof CommiteeSlugPrestationParticipationsChar123IdChar125Route
  CommiteeSlugPrestationCreateRoute: typeof CommiteeSlugPrestationCreateRoute
  CommiteeSlugPrestationChar123IdChar125Route: typeof CommiteeSlugPrestationChar123IdChar125Route
  CommiteeSlugSuppliersCreateRoute: typeof CommiteeSlugSuppliersCreateRoute
  CommiteeSlugSuppliersChar123IdChar125Route: typeof CommiteeSlugSuppliersChar123IdChar125Route
  CommiteeSlugTreasuryCashRegisterRoute: typeof CommiteeSlugTreasuryCashRegisterRoute
  CommiteeSlugTreasuryPendingDisbursementsRoute: typeof CommiteeSlugTreasuryPendingDisbursementsRoute
  CommiteeSlugTreasuryPendingPaymentsRoute: typeof CommiteeSlugTreasuryPendingPaymentsRoute
  CommiteeSlugImmobilisationsIndexRoute: typeof CommiteeSlugImmobilisationsIndexRoute
  CommiteeSlugInventoryIndexRoute: typeof CommiteeSlugInventoryIndexRoute
  CommiteeSlugInvoicesIndexRoute: typeof CommiteeSlugInvoicesIndexRoute
  CommiteeSlugOrdersIndexRoute: typeof CommiteeSlugOrdersIndexRoute
  CommiteeSlugPrestationParticipationsIndexRoute: typeof CommiteeSlugPrestationParticipationsIndexRoute
  CommiteeSlugPrestationRulesIndexRoute: typeof CommiteeSlugPrestationRulesIndexRoute
  CommiteeSlugPrestationIndexRoute: typeof CommiteeSlugPrestationIndexRoute
  CommiteeSlugSuppliersIndexRoute: typeof CommiteeSlugSuppliersIndexRoute
  CommiteeSlugAccountingBankReconciliationsCreationRoute: typeof CommiteeSlugAccountingBankReconciliationsCreationRoute
  CommiteeSlugAccountingBankReconciliationsChar123IdChar125Route: typeof CommiteeSlugAccountingBankReconciliationsChar123IdChar125Route
  CommiteeSlugAccountingClosingChar123IdChar125Route: typeof CommiteeSlugAccountingClosingChar123IdChar125Route
  CommiteeSlugAccountingParametersAccountPeriodsRoute: typeof CommiteeSlugAccountingParametersAccountPeriodsRoute
  CommiteeSlugAccountingParametersBanksRoute: typeof CommiteeSlugAccountingParametersBanksRoute
  CommiteeSlugAccountingTransactionsChar123IdChar125Route: typeof CommiteeSlugAccountingTransactionsChar123IdChar125Route
  CommiteeSlugBeneficiariesEmployeesBeneficiariesChar123IdChar125Route: typeof CommiteeSlugBeneficiariesEmployeesBeneficiariesChar123IdChar125Route
  CommiteeSlugBeneficiariesEmployeesChar123IdChar125Route: typeof CommiteeSlugBeneficiariesEmployeesChar123IdChar125Route
  CommiteeSlugBeneficiariesTransactionsChar123IdChar125Route: typeof CommiteeSlugBeneficiariesTransactionsChar123IdChar125Route
  CommiteeSlugTreasuryBankDepositsDepositSlipNumberRoute: typeof CommiteeSlugTreasuryBankDepositsDepositSlipNumberRoute
  CommiteeSlugAccountingFecIndexRoute: typeof CommiteeSlugAccountingFecIndexRoute
  CommiteeSlugAccountingParametersIndexRoute: typeof CommiteeSlugAccountingParametersIndexRoute
  CommiteeSlugAccountingReportsIndexRoute: typeof CommiteeSlugAccountingReportsIndexRoute
  CommiteeSlugBeneficiariesBilletterieOrdersIndexRoute: typeof CommiteeSlugBeneficiariesBilletterieOrdersIndexRoute
  CommiteeSlugBeneficiariesDebtsIndexRoute: typeof CommiteeSlugBeneficiariesDebtsIndexRoute
  CommiteeSlugTreasuryBankDepositsIndexRoute: typeof CommiteeSlugTreasuryBankDepositsIndexRoute
  CommiteeSlugAccountingParametersFinancialAccountsChar123IdChar125Route: typeof CommiteeSlugAccountingParametersFinancialAccountsChar123IdChar125Route
  CommiteeSlugAccountingParametersJournalsChar123IdChar125Route: typeof CommiteeSlugAccountingParametersJournalsChar123IdChar125Route
  CommiteeSlugAccountingParametersTransactionCategoriesChar123IdChar125Route: typeof CommiteeSlugAccountingParametersTransactionCategoriesChar123IdChar125Route
  CommiteeSlugSuppliersSupplierIdOrdersCreateRoute: typeof CommiteeSlugSuppliersSupplierIdOrdersCreateRoute
  CommiteeSlugSuppliersSupplierIdPaymentsCreateRoute: typeof CommiteeSlugSuppliersSupplierIdPaymentsCreateRoute
  CommiteeSlugAccountingParametersTransactionModelsIndexRoute: typeof CommiteeSlugAccountingParametersTransactionModelsIndexRoute
  CommiteeSlugBeneficiariesTransactionsCreateIndexRoute: typeof CommiteeSlugBeneficiariesTransactionsCreateIndexRoute
}

const CommiteeSlugRouteChildren: CommiteeSlugRouteChildren = {
  CommiteeSlugIndexRoute: CommiteeSlugIndexRoute,
  CommiteeSlugAccountDetailsRoute: CommiteeSlugAccountDetailsRoute,
  CommiteeSlugCreditNotesCreateRoute: CommiteeSlugCreditNotesCreateRoute,
  CommiteeSlugImmobilisationsCreateRoute:
    CommiteeSlugImmobilisationsCreateRoute,
  CommiteeSlugImmobilisationsChar123IdChar125Route:
    CommiteeSlugImmobilisationsChar123IdChar125Route,
  CommiteeSlugInvoicesInvoiceIdRoute: CommiteeSlugInvoicesInvoiceIdRoute,
  CommiteeSlugOrdersOrderIdRoute: CommiteeSlugOrdersOrderIdRoute,
  CommiteeSlugOrdersCreateRoute: CommiteeSlugOrdersCreateRoute,
  CommiteeSlugPrestationParticipationsCreateRoute:
    CommiteeSlugPrestationParticipationsCreateRoute,
  CommiteeSlugPrestationParticipationsChar123IdChar125Route:
    CommiteeSlugPrestationParticipationsChar123IdChar125Route,
  CommiteeSlugPrestationCreateRoute: CommiteeSlugPrestationCreateRoute,
  CommiteeSlugPrestationChar123IdChar125Route:
    CommiteeSlugPrestationChar123IdChar125Route,
  CommiteeSlugSuppliersCreateRoute: CommiteeSlugSuppliersCreateRoute,
  CommiteeSlugSuppliersChar123IdChar125Route:
    CommiteeSlugSuppliersChar123IdChar125Route,
  CommiteeSlugTreasuryCashRegisterRoute: CommiteeSlugTreasuryCashRegisterRoute,
  CommiteeSlugTreasuryPendingDisbursementsRoute:
    CommiteeSlugTreasuryPendingDisbursementsRoute,
  CommiteeSlugTreasuryPendingPaymentsRoute:
    CommiteeSlugTreasuryPendingPaymentsRoute,
  CommiteeSlugImmobilisationsIndexRoute: CommiteeSlugImmobilisationsIndexRoute,
  CommiteeSlugInventoryIndexRoute: CommiteeSlugInventoryIndexRoute,
  CommiteeSlugInvoicesIndexRoute: CommiteeSlugInvoicesIndexRoute,
  CommiteeSlugOrdersIndexRoute: CommiteeSlugOrdersIndexRoute,
  CommiteeSlugPrestationParticipationsIndexRoute:
    CommiteeSlugPrestationParticipationsIndexRoute,
  CommiteeSlugPrestationRulesIndexRoute: CommiteeSlugPrestationRulesIndexRoute,
  CommiteeSlugPrestationIndexRoute: CommiteeSlugPrestationIndexRoute,
  CommiteeSlugSuppliersIndexRoute: CommiteeSlugSuppliersIndexRoute,
  CommiteeSlugAccountingBankReconciliationsCreationRoute:
    CommiteeSlugAccountingBankReconciliationsCreationRoute,
  CommiteeSlugAccountingBankReconciliationsChar123IdChar125Route:
    CommiteeSlugAccountingBankReconciliationsChar123IdChar125Route,
  CommiteeSlugAccountingClosingChar123IdChar125Route:
    CommiteeSlugAccountingClosingChar123IdChar125Route,
  CommiteeSlugAccountingParametersAccountPeriodsRoute:
    CommiteeSlugAccountingParametersAccountPeriodsRoute,
  CommiteeSlugAccountingParametersBanksRoute:
    CommiteeSlugAccountingParametersBanksRoute,
  CommiteeSlugAccountingTransactionsChar123IdChar125Route:
    CommiteeSlugAccountingTransactionsChar123IdChar125Route,
  CommiteeSlugBeneficiariesEmployeesBeneficiariesChar123IdChar125Route:
    CommiteeSlugBeneficiariesEmployeesBeneficiariesChar123IdChar125Route,
  CommiteeSlugBeneficiariesEmployeesChar123IdChar125Route:
    CommiteeSlugBeneficiariesEmployeesChar123IdChar125Route,
  CommiteeSlugBeneficiariesTransactionsChar123IdChar125Route:
    CommiteeSlugBeneficiariesTransactionsChar123IdChar125Route,
  CommiteeSlugTreasuryBankDepositsDepositSlipNumberRoute:
    CommiteeSlugTreasuryBankDepositsDepositSlipNumberRoute,
  CommiteeSlugAccountingFecIndexRoute: CommiteeSlugAccountingFecIndexRoute,
  CommiteeSlugAccountingParametersIndexRoute:
    CommiteeSlugAccountingParametersIndexRoute,
  CommiteeSlugAccountingReportsIndexRoute:
    CommiteeSlugAccountingReportsIndexRoute,
  CommiteeSlugBeneficiariesBilletterieOrdersIndexRoute:
    CommiteeSlugBeneficiariesBilletterieOrdersIndexRoute,
  CommiteeSlugBeneficiariesDebtsIndexRoute:
    CommiteeSlugBeneficiariesDebtsIndexRoute,
  CommiteeSlugTreasuryBankDepositsIndexRoute:
    CommiteeSlugTreasuryBankDepositsIndexRoute,
  CommiteeSlugAccountingParametersFinancialAccountsChar123IdChar125Route:
    CommiteeSlugAccountingParametersFinancialAccountsChar123IdChar125Route,
  CommiteeSlugAccountingParametersJournalsChar123IdChar125Route:
    CommiteeSlugAccountingParametersJournalsChar123IdChar125Route,
  CommiteeSlugAccountingParametersTransactionCategoriesChar123IdChar125Route:
    CommiteeSlugAccountingParametersTransactionCategoriesChar123IdChar125Route,
  CommiteeSlugSuppliersSupplierIdOrdersCreateRoute:
    CommiteeSlugSuppliersSupplierIdOrdersCreateRoute,
  CommiteeSlugSuppliersSupplierIdPaymentsCreateRoute:
    CommiteeSlugSuppliersSupplierIdPaymentsCreateRoute,
  CommiteeSlugAccountingParametersTransactionModelsIndexRoute:
    CommiteeSlugAccountingParametersTransactionModelsIndexRoute,
  CommiteeSlugBeneficiariesTransactionsCreateIndexRoute:
    CommiteeSlugBeneficiariesTransactionsCreateIndexRoute,
}

const CommiteeSlugRouteWithChildren = CommiteeSlugRoute._addFileChildren(
  CommiteeSlugRouteChildren,
)

interface AccountLieuDeTravailRouteChildren {
  AccountLieuDeTravailIdRoute: typeof AccountLieuDeTravailIdRoute
  AccountLieuDeTravailIndexRoute: typeof AccountLieuDeTravailIndexRoute
}

const AccountLieuDeTravailRouteChildren: AccountLieuDeTravailRouteChildren = {
  AccountLieuDeTravailIdRoute: AccountLieuDeTravailIdRoute,
  AccountLieuDeTravailIndexRoute: AccountLieuDeTravailIndexRoute,
}

const AccountLieuDeTravailRouteWithChildren =
  AccountLieuDeTravailRoute._addFileChildren(AccountLieuDeTravailRouteChildren)

interface GestionEntrepriseIdRouteChildren {
  GestionEntrepriseIdBanqueRoute: typeof GestionEntrepriseIdBanqueRoute
  GestionEntrepriseIdLieuDeTravailRoute: typeof GestionEntrepriseIdLieuDeTravailRoute
  GestionEntrepriseIdUsersRoute: typeof GestionEntrepriseIdUsersRoute
  GestionEntrepriseIdIndexRoute: typeof GestionEntrepriseIdIndexRoute
}

const GestionEntrepriseIdRouteChildren: GestionEntrepriseIdRouteChildren = {
  GestionEntrepriseIdBanqueRoute: GestionEntrepriseIdBanqueRoute,
  GestionEntrepriseIdLieuDeTravailRoute: GestionEntrepriseIdLieuDeTravailRoute,
  GestionEntrepriseIdUsersRoute: GestionEntrepriseIdUsersRoute,
  GestionEntrepriseIdIndexRoute: GestionEntrepriseIdIndexRoute,
}

const GestionEntrepriseIdRouteWithChildren =
  GestionEntrepriseIdRoute._addFileChildren(GestionEntrepriseIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  CommiteeSlugRoute: CommiteeSlugRouteWithChildren,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  AccountBanqueRoute: AccountBanqueRoute,
  AccountDetailsRoute: AccountDetailsRoute,
  AccountEntrepriseRoute: AccountEntrepriseRoute,
  AccountLieuDeTravailRoute: AccountLieuDeTravailRouteWithChildren,
  AccountUsersRoute: AccountUsersRoute,
  GestionCreateRoute: GestionCreateRoute,
  GestionGeneralRoute: GestionGeneralRoute,
  GestionEntrepriseIdRoute: GestionEntrepriseIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
